import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import Container from "@material-ui/core/Container/Container";
import ScrollToTop from './common/ScrollToTop';
import AuthContextProvider from "./contexts/authContext";

import HomePage from './containers/homepage/homePage';
import LoginPage from './containers/loginPage/loginPage';
import Welcome from './containers/welcomePage/welcome';
import PageNotFound from './containers/pageNotFound/pageNotFound';

import Footer from './common/footer';
import './App.css';
import GA from './components/googleAnalytics'

import ReactGA from 'react-ga';
ReactGA.initialize('UA-148227012-1');

class App extends Component {

  render() {
    return (
        <div>
          <Container maxWidth="xl">
            <div className="App">
              <AuthContextProvider>
                <Router>
                  { GA.init() && <GA.RouteTracker /> }
                  <ScrollToTop>
                    <Switch>
                      <Route exact path='/' component={LoginPage} />
                      <Route exact path='/welcome' component={Welcome} />
                      <Route exact path='/home/:category' component={HomePage} />
                      <Route path="*" component={PageNotFound} />
                    </Switch>
                  </ScrollToTop>
                </Router>
              </AuthContextProvider>
            </div>
            <Footer />
          </Container>
        </div>
    );
  }
}

export default App;
